import React, { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../App';
import axios from 'axios';
import { LoadingOverlay } from '../../loading';
import { FaArrowRotateRight } from "react-icons/fa6";


const CountdownTimer = ({ serverTime, timeLeft, setTimeLeft }) => {

  useEffect(() => {
    if (!serverTime) return;

    const serverDate = new Date(serverTime).getTime();

    const updateCountdown = () => {
      const now = Date.now();
      const difference = serverDate - now + 10 * 60 * 1000;
      if (difference <= 0) {
          clearInterval(interval); // Stop countdown
          setTimeLeft(null); // Undgå negativ tid
      } else {
          setTimeLeft(difference);
      }
    };

    updateCountdown(); // Kør den én gang ved start
    const interval = setInterval(updateCountdown, 1000);

    return () => clearInterval(interval); // Ryd op
  }, [serverTime]); // Kun kør når `serverTime` ændres!

  if (timeLeft === null) return;

  const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
  const seconds = Math.floor((timeLeft / 1000) % 60);

  return (
    <h2>{minutes}:{seconds.toString().padStart(2, "0")}</h2>
  );
};

const VerificationCodeInput = ({ onComplete, setErrorMessage }) => {
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const inputsRef = useRef([]);

  useEffect(() => {
    if (inputsRef.current[0]) {
      inputsRef.current[0].focus();
    }
  }, []);

  const handleChange = (index, value) => {
    if (!/^\d?$/.test(value)) return; // Tillad kun ét tal pr. felt

    const newCode = [...code];
    newCode[index] = value;
    setCode(newCode);

    // Flyt fokus til næste felt
    if (value && index < 5) {
      inputsRef.current[index + 1].focus();
    }

    // Kald onComplete når alle felter er udfyldt
    if (newCode.every((digit) => digit !== "")) {
      onComplete(newCode.join(""));
    }
  };

  const handleKeyDown = (index, e) => {
    setErrorMessage('')
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputsRef.current[index - 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").trim();

    if (/^\d{6}$/.test(pastedData)) {
      const newCode = pastedData.split("");
      setCode(newCode);

      // Flyt fokus til sidste felt
      inputsRef.current[5].focus();

      // Kald onComplete med den indsatte kode
      onComplete(pastedData);
    }
  };

  return (
    
    <div className="space-y-4 md:space-y-6">
      <div className="flex justify-between max-w-[400px] gap-2 mx-auto" onPaste={handlePaste}>
        {code.map((digit, index) => (
          <input
            key={index}
            ref={(el) => (inputsRef.current[index] = el)}
            type="text"
            inputMode="numeric"
            maxLength="1"
            value={digit}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            className="w-full max-w-12 h-16 text-center text-lg border border-gray-300 focus:outline-none"
          />
        ))}
      </div>
      <button type="submit" onClick={() => onComplete(code.join(""))} className="focus:bg-pos-100 w-full text-white bg-gradient-to-r from-emerald-600 to-emerald-700 bg-pos-0 bg-size-200 hover:bg-pos-100 transition-all duration-150 ease-in-out outline-none font-medium text-sm px-5 py-2.5 text-center">Bekræft</button>
    </div>
  )
}

export default function VerifyPhone({ goToNextStep }) {
  const { user, setUser } = useContext(UserContext)
  const [isLoading, setIsLoading] = useState(false)
  const [successMessage, setSuccessMessage] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [serverTime, setServerTime] = useState()
  const [timeLeft, setTimeLeft] = useState(null);
  const navigate = useNavigate()
  const token = localStorage.getItem('token')

  useEffect(() => {
    window.scrollTo({top: 0, behavior: 'auto'})
  }, [])

  const handleCode = (fullCode) => {
    setSuccessMessage('')
    setErrorMessage('')
    setIsLoading(true)
    axios({
      method: 'post',
      url: '/api/verifyPhone',
      data: {
        code: fullCode
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(response => {
      console.log(user)
      const updatedUser = {
        ...user,
        verified_phone: true
      };
      setUser(updatedUser)
      console.log(updatedUser)
      goToNextStep(updatedUser)
      setIsLoading(false)
    })
    .catch(error => {
      setErrorMessage('Den indtastede kode er forkert')
      setIsLoading(false)
    });
  }

  const newCode = () => {
    if (timeLeft !== null) {
      return;
    }
    setErrorMessage('')
    setSuccessMessage('')
    setIsLoading(true)
    axios({
      method: 'post',
      url: '/api/newPhone',
      data: {
        phone: user.phone
      },
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    .then(response => {
      setSuccessMessage('En ny kode blev sendt!')
      setServerTime(response.data.date)
      setIsLoading(false)
    })
    .catch(error => {
      if (error.response.data.type === 1) {
        setUser(prev => ({
          ...prev,
          "verified_phone": true
        }))
      } else {
        setServerTime(error.response.data.date)
      }
      setIsLoading(false)
    });
  }

  return (
    <>
      {(isLoading) ?
        <div className="absolute h-lvh w-full z-20 top-0 left-0">
          <LoadingOverlay />
        </div>
      :
          ""
      }
      <div className="w-full bg-white">
          <div className="space-y-4">
              {(successMessage !== '') ?
                  <div className="py-2 px-4 text-sm bg-emerald-300 bg-opacity-50">
                      <p>{successMessage}</p>
                  </div>
              :
                  ""}
              <h1 className="text-base xl:text-lg font-medium leading-none">
                  Indtast bekræftelseskode
              </h1>
              <p>Vi har sendt en bekræftelseskode til <br></br><span className="font-semibold">+45 {user.phone?.slice(2).replace(/(\d{2})(?=\d)/g, "$1 ")}</span></p>
              {(errorMessage !== '') ?
                  <div className="text-center text-sm w-full py-4 px-2 bg-red-200">
                      <p>{errorMessage}</p>
                  </div>
              :
                  ""
              }
              <VerificationCodeInput onComplete={handleCode} setErrorMessage={setErrorMessage} />
              <div className="space-y-1">
                  <h2 className="font-medium">Har du ikke modtaget en SMS?</h2>
                  <p className="text-sm">Det kan tage op til 5 minutter.</p>
              </div>
              <div className="flex gap-2 items-center w-fit">
                <div className={"flex gap-2 items-center w-fit " + (timeLeft !== null ? "opacity-50 select-none" : "cursor-pointer")} onClick={newCode}>
                  <FaArrowRotateRight />
                  <h2 className="text-sm font-bold uppercase">Send ny kode</h2>
                </div>
                <CountdownTimer serverTime={serverTime} timeLeft={timeLeft} setTimeLeft={setTimeLeft} />
              </div>
          </div>
      </div>
    </>
  )
}